import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";

export const TIER_LABEL = { amazing: "Amazing", great: "Great", good: "Good" };
export const MODE_LABEL = { pvp: "Arena & Atlantis", pve: "Historic Battles & Tesla" };

export const assetUrlMap = (assets) => Object.fromEntries(
  Object.entries(assets || {}).map(([k, a]) => [k, { ...a, url: a.url || (a.file ? fileUrl(`/api/files/id/${a.file}`) : "") }]));

export const useGearData = () => {
  const [catalog, setCatalog] = useState(null);
  const [assets, setAssets] = useState({});
  const loadAssets = () => api.get("/public/gear-assets").then((r) => setAssets(assetUrlMap(r.data)));
  useEffect(() => {
    api.get("/public/gear-catalog").then((r) => setCatalog(r.data));
    loadAssets();
  }, []);
  return { catalog, assets, loadAssets };
};

export const GearCardView = ({ piece, catalog, assets, badge }) => {
  const html = window.GearCards ? window.GearCards.card(piece, { catalog, assets, badge }) : "";
  useEffect(() => { if (window.GearCards) window.GearCards.inject(document); }, []);
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};
